// extracted by mini-css-extract-plugin
export var link = "_sy-0";